import { EnergyIcon } from '../types/energy.types';

interface EnergyIconSelectorProps {
  icons: EnergyIcon[];
  selectedIcons: Set<string>;
  onToggle: (iconId: string) => void;
}

export const EnergyIconSelector = ({
  icons,
  selectedIcons,
  onToggle,
}: EnergyIconSelectorProps) => {
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
      {icons.map((icon) => (
        <button
          key={icon.id}
          onClick={() => onToggle(icon.id)}
          className={`flex items-center gap-3 rounded-xl border p-3 text-left transition-all ${
            selectedIcons.has(icon.id)
              ? 'border-primary-3 bg-primary-5'
              : 'border-gray-4 bg-mono-1 hover:border-gray-3 hover:bg-gray-5'
          }`}
        >
          <div className="text-2xl">{icon.emoji}</div>
          <div className="flex-1">
            <div className="text-gray-1 text-sm font-semibold">
              {icon.title}
            </div>
            <div className="text-gray-2 text-xs">{icon.desc}</div>
          </div>
        </button>
      ))}
    </div>
  );
};
